// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ATdx","right":"Footer_right__oI7Gj","buttons":"Footer_buttons__3OSNZ"};